import { MonoTypeOperatorFunction, timer } from 'rxjs';
import { retryWhen, mergeMap } from 'rxjs/operators';

export function retryWithBackoff<T>(
  retries = 3,
  delayMs = 1000
): MonoTypeOperatorFunction<T> {

  return retryWhen(errors =>
    errors.pipe(
      mergeMap((error, index) => {
        if (index >= retries) {
          throw error;
        }
        return timer(delayMs * (index + 1));
      })
    )
  );
}
